/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.querySelector('.thb-quick-search');
    this.button = document.getElementById('quick-search');
    this.close_button = this.container.querySelector('.thb-search-close');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');
    this.inlineInput = document.querySelector('.header-inline-search__input');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.container.querySelector('form.searchform');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      if (this.inlineInput) {
        this.inlineInput.value = this.input.value;
      }
      this.onChange(event);
    }, 300).bind(this));

    this.button.addEventListener('click', (event) => {
      var _this = this;
      event.preventDefault();

      // HG UX: below the desktop breakpoint the header row field is the only search field. Once it has
      // collapsed on scroll, the icon reveals and focuses that same field (same design, same query,
      // same results panel) instead of opening the second, differently styled form.
      if (this.usesInlineRow()) {
        const root = document.documentElement;
        root.classList.add('hg-search-reveal');
        // the field's focus handler re-opens the results for an existing query
        this.inlineInput.focus({ preventScroll: true });
        requestAnimationFrame(() => root.classList.remove('hg-search-reveal'));
        dispatchCustomEvent('search:open');
        return false;
      }

      document.querySelector('.header-section').classList.toggle('search-open');

      if (document.querySelector('.header-section').classList.contains('search-open')) {
        setTimeout(function () {
          _this.input.focus({
            preventScroll: true
          });
        }, 100);
        dispatchCustomEvent('search:open');
      }

      return false;
    });

    // Inline search bar (desktop)
    if (this.inlineInput) {
      this.inlineInput.addEventListener('input', debounce((event) => {
        this.input.value = this.inlineInput.value;
        if (!document.querySelector('.header-section').classList.contains('search-open')) {
          this.open();
        }
        this.onChange(event);
      }, 300).bind(this));

      this.inlineInput.addEventListener('focus', () => {
        if (this.inlineInput.value.trim().length > 0) {
          this.input.value = this.inlineInput.value;
          if (!document.querySelector('.header-section').classList.contains('search-open')) {
            this.open();
          }
          this.onChange();
        }
      });

      // Prevent inline form from navigating — use the predictive results instead
      const inlineForm = this.inlineInput.closest('form');
      if (inlineForm) {
        inlineForm.addEventListener('submit', (event) => {
          if (!this.inlineInput.value.trim().length) {
            event.preventDefault();
          }
        });
      }
    }

    // Close.
    this.close_button.addEventListener('click', (event) => {
      this.close();
      event.preventDefault();
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  usesInlineRow() {
    if (!this.inlineInput || !window.matchMedia('(max-width: 1067px)').matches) return false;
    const row = this.inlineInput.closest('.header-inline-search');
    return !!row && getComputedStyle(row).display !== 'none';
  }

  categoryToggle() {
    this.category_toggle = this.container.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.container.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        this.container.querySelector(target).classList.add('active');

        event.preventDefault();
      });
    });

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    // HG (E1): categories too, and up to 10 results PER type (limit_scope=each), so articles and suggestions no
    // longer take product slots. Query suggestions are German search terms: only on the German storefront (E2).
    const types = ['product', 'collection', 'article', 'page'];
    if ((document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0) types.push('query');
    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${types.join(',')}&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.predictiveSearchResults.classList.add('active');

    this.categoryToggle();
  }

  open() {
    document.querySelector('.header-section').classList.add('search-open');
  }

  close() {
    document.querySelector('.header-section').classList.remove('search-open');
    if (this.inlineInput) {
      this.inlineInput.value = this.input.value;
    }
  }
}
/* HG (B14): start as soon as the DOM is ready (was: window 'load', i.e. after every image), so the always-visible
   mobile field suggests from the first keystrokes. If the shopper already typed into the focused field before
   that, run the search once. */
function hgStartPredictiveSearch() {
  if (typeof PredictiveSearch === 'undefined' || window.hgPredictiveSearch) return;
  const ps = window.hgPredictiveSearch = new PredictiveSearch();
  const inline = ps.inlineInput;
  if (inline && document.activeElement === inline && inline.value.trim().length) {
    ps.input.value = inline.value;
    ps.open();
    ps.onChange();
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hgStartPredictiveSearch);
} else {
  hgStartPredictiveSearch();
}